module.exports = __webpack_public_path__ + "img/newTechnology.16923a5c.jpg";